import React from 'react'
import { Container, Card, Row, Col } from "reactstrap"
import Styled from 'styled-components'
import BoxWhite from 'Placements/Components/BoxWhite'


const CardStyled = Styled(BoxWhite)`
    .box-white{
        margin-top: 3rem !important;
    } 
`

const DivStyled = Styled.div`
    display:flex;
    margin-left: -30px;
    margin-top: -35px;

    .part{
        background-color: #1fbfd9;
        padding: .5rem 1rem;
        color: white;
    }

    .number{
        background-color: #66279b;
        padding: .5rem 1rem;
        color: white;
        font-size: 1rem;
        font-weight: 'bold' 
        align-self: flex-end;
        margin-left: 5px;
    }
`

const CardExercice = (props: any) => {

    const { children, testName, question, tooltip } = props
    return (
        <Col md={8} style={{ marginTop: '3rem' }}>
            <CardStyled>
                <DivStyled>
                    <span className="part">{testName}</span>
                    <span className="number">{question}</span>
                </DivStyled>
                {tooltip &&
                    <div className="exercice-tooltip">
                        <div className="symbol">?</div>
                        <div className="text">{tooltip}</div>
                    </div>
                }
                {children}
            </CardStyled>
        </Col>
    )
}

export default CardExercice